"use client";

import { Button } from "@repo/ui/components/ui/button";
import { useRouter } from "next/navigation";
import { revalidatePath } from "next/cache";
import { redirect } from "next/navigation";
import { useTranslations } from "next-intl";

function error({
  statusCode,
  reset,
}: {
  statusCode?: number;
  reset: () => void;
}) {
  const router = useRouter();
  const t = useTranslations();

  function backAndReload() {
    window.location.href = "/";
  }

  return (
    <div className="h-96 w-full flex flex-col items-center justify-center gap-5">
      <div>
        <h3>
          {statusCode
            ? `An error ${statusCode} occurred on server`
            : "Ops, qualcosa è andato storto"}
        </h3>
      </div>
      <div className="flex gap-4">
        <Button variant="outline" onClick={backAndReload}>
          {t("home")}
        </Button>
        <Button onClick={reset}>{t("retry")}</Button>
      </div>
    </div>
  );
}

error.getInitialProps = ({ res, err }: { res?: any; err?: any }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode };
};

export default error;
